import { useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock, FaSignInAlt } from "react-icons/fa";

function Login() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        email: "",
        password: ""
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.email || !form.password) {
            alert("Please fill in all fields.");
            return;
        }

        try {
            setLoading(true);
            const response = await API.post("/auth/login", form);

            localStorage.setItem("token", response.data.token);
            localStorage.setItem("role", response.data.user.role);

            navigate("/dashboard");
        } catch (error) {
            alert(error.response?.data?.message || "Login failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="d-flex align-items-center justify-content-center min-vh-100 p-3"
            style={{
                background: "radial-gradient(circle at 50% 50%, #1e1b4b 0%, #0f172a 100%)",
                position: "relative",
                overflow: "hidden"
            }}
        >
            {/* Background decorative glowing circles */}
            <div
                style={{
                    position: "absolute",
                    width: "300px",
                    height: "300px",
                    background: "rgba(79, 70, 229, 0.15)",
                    borderRadius: "50%",
                    filter: "blur(80px)",
                    top: "10%",
                    left: "15%"
                }}
            />
            <div
                style={{
                    position: "absolute",
                    width: "300px",
                    height: "300px",
                    background: "rgba(16, 185, 129, 0.1)",
                    borderRadius: "50%",
                    filter: "blur(80px)",
                    bottom: "10%",
                    right: "15%"
                }}
            />

            <div
                className="w-100 animate-fade-in"
                style={{ maxWidth: "420px", zIndex: 10 }}
            >
                <div
                    className="card border-0 shadow-lg"
                    style={{
                        background: "rgba(30, 41, 59, 0.7)",
                        backdropFilter: "blur(16px)",
                        border: "1px solid rgba(255, 255, 255, 0.08) !important",
                        color: "#f8fafc",
                        padding: "2rem 1.5rem"
                    }}
                >
                    <div className="card-body p-0">
                        <div className="text-center mb-4">
                            <div className="mb-3">
                                <img
                                    src="/logo.png"
                                    alt="Entropy Connect Logo"
                                    width="60"
                                    height="60"
                                    style={{ objectFit: "contain" }}
                                />
                            </div>
                            <h2 className="fw-extrabold text-white mb-2">
                                Welcome Back
                            </h2>
                            <p style={{ color: "#94a3b8" }}>
                                Enter your credentials to access Entropy Connect
                            </p>
                        </div>

                        <form onSubmit={handleSubmit}>
                            {/* Email */}
                            <div className="mb-3">
                                <label className="form-label small fw-semibold text-uppercase" style={{ letterSpacing: "0.5px", color: "#cbd5e1" }}>
                                    Email Address
                                </label>
                                <div className="input-group">
                                    <span
                                        className="input-group-text border-0"
                                        style={{
                                            background: "rgba(15, 23, 42, 0.5)",
                                            color: "#94a3b8",
                                            borderRadius: "10px 0 0 10px"
                                        }}
                                    >
                                        <FaEnvelope />
                                    </span>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="name@agency.com"
                                        className="form-control text-white border-0"
                                        style={{
                                            background: "rgba(15, 23, 42, 0.5)",
                                            borderRadius: "0 10px 10px 0"
                                        }}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Password */}
                            <div className="mb-4">
                                <label className="form-label small fw-semibold text-uppercase" style={{ letterSpacing: "0.5px", color: "#cbd5e1" }}>
                                    Password
                                </label>
                                <div className="input-group">
                                    <span
                                        className="input-group-text border-0"
                                        style={{
                                            background: "rgba(15, 23, 42, 0.5)",
                                            color: "#94a3b8",
                                            borderRadius: "10px 0 0 10px"
                                        }}
                                    >
                                        <FaLock />
                                    </span>
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="••••••••"
                                        className="form-control text-white border-0"
                                        style={{
                                            background: "rgba(15, 23, 42, 0.5)",
                                            borderRadius: "0 10px 10px 0"
                                        }}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 py-3 mt-2"
                                style={{
                                    boxShadow: "0 4px 14px rgba(79, 70, 229, 0.4)",
                                    fontSize: "1rem"
                                }}
                                disabled={loading}
                            >
                                {loading ? (
                                    "Logging in..."
                                ) : (
                                    <>
                                        <FaSignInAlt /> Login
                                    </>
                                )}
                            </button>
                        </form>

                        <div className="text-center mt-4 pt-2">
                            {/* <p className="mb-0 text-muted small">
                                Don't have an account?{" "}
                                <Link 
                                    to="/register" 
                                    className="text-primary text-decoration-none fw-bold"
                                    style={{ color: "#818cf8 !important" }}
                                >
                                    Register Here
                                </Link>
                            </p> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;